function importLayout() {
    return () =>
        import ('@/layouts/default')
}
function commonLayout() {
    return () =>
        import ('@/layouts/CommonLayout')
}

export default [{
        path: '*',
        redirect: {
            path: '/login'
        }
    },
    {
        path: '/404',
        name: 'NotFound',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/NotFound.vue`
            )
    },
    {
        path: '/403',
        name: 'AccessDenied',
        component: () =>
            import (
                /* webpackChunkName: "routes" */
                `@/views/errors/Deny.vue`
            )
    },
    {
        path: '/500',
        name: 'ServerError',
        component: () =>
            import (
                `@/views/errors/Error.vue`
            )
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import (
                `@/views/auth/Register.vue`
            ),
    },
    {
        path: '/trekking-system/register',
        name: 'RealRegister',
        component: () =>
            import (
                `@/views/auth/RegistrationVerification.vue`
                ),
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import (
                `@/views/auth/Login.vue`
            ),
    },

    {
        path: '/forget-password',
        name: 'ForgetPassword',
        component: () =>
            import (
                `@/views/resetpassword/ForgetPassword.vue`
                ),
    },
    {
        path: '/password/reset',
        name: 'ResetPassword',
        component: () =>
            import (
                `@/views/resetpassword/TokenVerification.vue`
                ),
    },

    {
        path: '/system',
        component: importLayout(),

        children: [{
                path: '/',
                redirect: {
                    path: '/system/dashboard'
                },
            },
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: () =>
                    import (
                        `@/views/Dashboard.vue`
                        ),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/trekking-request',
                name: 'TrekkingRequestList',
                component: () =>
                    import (
                        `@/views/trekkingrequest/list.vue`
                        ),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/trekking-request/create',
                name: 'TrekkingRequestNew',
                component: () =>
                    import (
                        `@/views/trekkingrequest/new.vue`
                    ),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/trekking-request/confirm',
                name: 'TrekkingRequestConfirm',
                component: () =>
                    import (
                        `@/views/trekkingrequest/confirm.vue`
                    ),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/trekking-request/view/:id',
                name: 'ViewTrekkingRequest',
                props: true,
                component: () =>
                    import (
                        `@/views/trekkingrequest/view.vue`
                    ),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: '/trekking-request/edit/:id',
                name: 'EditTrekkingRequest',
                props: true,
                component: () =>
                    import (
                        `@/views/trekkingrequest/edit.vue`
                        ),
                meta: {
                    requiresAuth: true,
                }
            },
            {
                path: 'profile',
                name: 'Profile',
                component: () =>
                    import (
                        `@/views/Profile.vue`
                    ),

                meta: {
                    requiresAuth: true
                }
            },
            {
                path: 'trekking-request-print',
                component: () =>
                    import (
                        `@/views/trekkingrequest/PrintPdf.vue`
                    ),
                meta: {
                    requiresAuth: true,
                    checkPermission: []
                },
                name: 'TrekkingRequestPrint'
            },
            {
                path: 'guides',
                component: () =>
                    import (
                        `@/views/Guide.vue`
                    ),
                meta: {
                    requiresAuth: true,
                    checkPermission: []
                },
                name: 'AddGuides',
            },
            {
                path: 'staffs',
                meta: {
                    requiresAuth: true
                },
                component: commonLayout(),
                children: [{
                    path: '/',
                    name: 'AddStaffs',
                    component: () =>
                        import (
                            `@/views/Staffs.vue`
                        ),
                    meta: {
                        requiresAuth: true,

                    }
                }, ]
            },

            // {
            //     path: 'passports',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component: commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'AddPassports',
            //         component: () =>
            //             import (
            //                 `@/views/Passport.vue`
            //             ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'tax-clearance-certificate',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component:commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'TaxClearanceCertificate',
            //         component: () =>
            //             import (
            //                 `@/views/TaxClearanceCertificate.vue`
            //             ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'nepal-tourism-board-certificate',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component: commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'NepalTourismCertificate',
            //         component: () =>
            //             import (
            //                 `@/views/NepalTourismBoardCertificate.vue`
            //             ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'nepal-rastra-bank-license',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component: commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'NepalRastraBankLicense',
            //         component: () =>
            //             import (
            //                 `@/views/NepalRastraBankLicense.vue`
            //             ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'domestic-and-small-industries-license',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component: commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'DomesticSmallIndustriesLicense',
            //         component: () =>
            //             import (
            //                 `@/views/DomesticSmallIndustryLicense.vue`
            //                 ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'company-registration-document',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component: commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'RegisterDocument',
            //         component: () =>
            //             import (
            //                 `@/views/RegisterDocument.vue`
            //                 ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'vat-pan-certificate',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component: commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'VatPanCertificate',
            //         component: () =>
            //             import (
            //                 `@/views/VatPanCertificate.vue`
            //                 ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            //
            // {
            //     path: 'history',
            //     meta: {
            //         requiresAuth: true
            //     },
            //     component:commonLayout(),
            //     children: [{
            //         path: '/',
            //         name: 'TrekkingHistory',
            //         component: () =>
            //             import (
            //                 `@/views/TrekkingHistory.vue`
            //             ),
            //         meta: {
            //             requiresAuth: true,
            //
            //         }
            //     }, ]
            // },
            {
                path: 'trekking-documents',
                meta: {
                    requiresAuth: true
                },
                component:commonLayout(),
                children: [{
                    path: '/',
                    name: 'TrekkingDocument',
                    component: () =>
                        import (
                            `@/views/TrekkingDocument.vue`
                        ),
                    meta: {
                        requiresAuth: true,

                    }
                }, ]
            },


        ]
    },

    {
        path: '/single-trekking-request/apply',
        name: 'SingleTrekkingRequestApply',
        component: () =>
            import (
                `@/views/singletrekkingrequest/Apply.vue`
                ),
    },

    {
        path: '/single-trekking-request/confirm',
        name: 'SingleTrekkingRequestConfirm',
        component: () =>
            import (
                `@/views/singletrekkingrequest/Confirm.vue`
                ),
    },
    {
        path: 'trekking-request-print',
        component: () =>
            import (
                `@/views/singletrekkingrequest/PrintPdf.vue`
                ),
        name: 'SingleTrekkingRequestPrint'
    },
]
